import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { CardHeader, Grid } from '@material-ui/core';
import { useStyles } from './DetalhesModalidadesStyles';
import ModalidadeTrapAmericano from './ModalidadeTrapAmericano';
import { Values } from '../../../../../values/Values';
import ModalidadeGeral from './ModalidadeGeral';


function DetalhesModalidades(props) {
  const {
    filiado,
    setFiliado,
    setShowMessageSnack,
    setMessageSnack,
    setTypeSnack,
    setLoading,
    filiacaoStatus,
    gruposSanguineos,
    edicao,
    visitaFiliado,
    setVisitaFiliado,
    modalidades,
    armas,
    insumos,
    pacotes
  } = props;
  const classes = useStyles();
  const [openAutocomplete, setOpenAutocomplete] = useState(false);
  const [filiados, setFiliados] = useState([]);
  const loadingUsers = openAutocomplete && filiados.length === 0;
  const [modalidadeSelecionada, setModalidadeSelecionada] = useState(null);

  return (

      <Grid
        container
      >
        <CardHeader
          subheader="Detalhes das modalidades utilizadas na visita."
          title="Modalidades"
        />
        <Grid
          md={12}
          xs={12}
        >
          {visitaFiliado.visitaFiliadoMods && visitaFiliado.visitaFiliadoMods.map((modalidade, index) => {
            if(modalidade.idModalidade === Values.Modalidades.trapAmericano ){
              return <ModalidadeTrapAmericano
                visitaFiliado={visitaFiliado}
                setVisitaFiliado={setVisitaFiliado}
                indexModalidade={index}
                setShowMessageSnack={setShowMessageSnack}
                setMessageSnack={setMessageSnack}
                setTypeSnack={setTypeSnack}
                setLoading={setLoading}
                armas={armas}
                insumos={insumos}
                pacotes={pacotes}
              />
            }
            else{
              return <ModalidadeGeral
                visitaFiliado={visitaFiliado}
                setVisitaFiliado={setVisitaFiliado}
                indexModalidade={index}
                indexVisitaFiliadoTrap={0}
                setShowMessageSnack={setShowMessageSnack}
                setMessageSnack={setMessageSnack}
                setTypeSnack={setTypeSnack}
                setLoading={setLoading}
                armas={armas}
                insumos={insumos}
                pacotes={pacotes}

              />
            }
          })}
        </Grid>
      </Grid>

  );
};

DetalhesModalidades.propTypes = {
  className: PropTypes.string,
  visitaFiliado: PropTypes.object.isRequired,
  setVisitaFiliado: PropTypes.object.isRequired
};

export default DetalhesModalidades;


